/* global htmlStyles */
const headElement = document.querySelector("head");

for (const htmlStyle of htmlStyles) {
  const styleElement = document.createElement("link");
  styleElement.setAttribute("href", htmlStyle);
  styleElement.setAttribute("rel", "stylesheet");
  styleElement.setAttribute("type", "text/css");
  headElement.insertAdjacentElement("beforeend", styleElement);
}
